import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
//Stripe Publish Key:
const stripePromise = loadStripe("pk_live_51Qin8HDVU3HZxbRKyYFB1jDD1gVVIbJHwwPP74EkkIhNrbOf0mbpgAh4cZ7Y5Js3h1BGFcHJn7f4NlYHX1qxFhrz00KjHXsgEp");

const StripeWrapper = ({ children }) => {
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeWrapper;